module.exports = __webpack_public_path__ + "static/media/ziele-fuer-nachhaltige-entwicklung.ef82b610.svg";